// src/components/layouts/AuthorLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthorSidebar from './AuthorSidebar';
import AuthorHeader from './AuthorHeader';

const AuthorLayout = () => {
  return (
    <div className="flex h-screen bg-gray-50">
      <AuthorSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <AuthorHeader />
         <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-8">
            <Outlet />
        
        </main>
      </div>
    </div>
  );
};

export default AuthorLayout;